import {OBJECT_SYNC_STORAGE} from '@vending/sync-engine-client';

/**
 * Fügt den Index `linkedToId` zum objectStore 'objects' der IndexedDB hinzu.
 * Der Index besteht aus den Feldern `entityType` und `content.customer_id`.
 * @param transaction - Die Transaktion für die Migration
 */
export function linkedToIdIndexMigration(transaction: IDBTransaction) {
  transaction
      .objectStore(OBJECT_SYNC_STORAGE)
      .createIndex(
          'linkedToId',
          ['entityType', 'content.linked_to_id'],
          {
            unique: false,
          }
      );
}
